import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AddGroupSessionComponent } from "../add-group-session/add-group-session.component";
import { MatDialog } from "@angular/material/dialog";
import { CounselingService } from "../../counseling.service";
import { DatePipe } from "@angular/common";
import firebase from "firebase/compat/app";
import { ViewGroupSessionComponent } from "../view-group-session/view-group-session.component";
import { EditGroupCounselingComponent } from "../edit-group-counseling/edit-group-counseling.component";
import { needConfirmation } from "../../../../confirm-dialog/confirm-dialog.decorator";
import Timestamp = firebase.firestore.Timestamp;
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectChange } from "@angular/material/select";
import { FormControl } from "@angular/forms";
import { CentreService } from "../../../../services/centre.service";
import { Observable } from "rxjs";
import { Centre, CentreOption } from "../../../../interfaces/Centres";
import { MatSort } from "@angular/material/sort";
import { UserRole } from "../../../../components/rename/add-user-role/add-user-role.component";
import { LogService } from "../../../../services/log.service";
import { EmployeeService } from "../../../../services/employee.service";
import { map } from "rxjs/operators";
import { PermissionType } from "../../../../components/employee/PermissionType.enum";
import { SubSink } from "subsink";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-group-session-table',
  templateUrl: './group-session-table.component.html',
  styleUrls: ['./group-session-table.component.scss']
})
export class GroupSessionTableComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns: string[] = ['sr.no', 'date', 'childrenNames', 'centres', 'topicsCovered', 'submittedBy', 'createdAt', 'Action'];
  dataSource!: MatTableDataSource<any>;
  selectedCentre: CentreOption | null = { centreName: 'All Centres', centreCode: 'All' } as CentreOption
  centreControl = new FormControl(this.selectedCentre)
  all = { centreName: 'All Centres', centreCode: 'All' }
  data: any
  mAllData: any
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('input') input!: ElementRef;
  sessionType: string | undefined | null = null

  @ViewChild(MatSort) sort!: MatSort;
  _centres$: Observable<CentreOption[]>;
  userData = JSON.parse(localStorage.getItem('userData')!).userName

  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  counselling = this.permissions.filter((x) => x.functionName == 'Counselling')
  currentDate = new Date().getTime()
  start: Date | undefined
  end: Date | undefined
  counsellors$: Observable<any[]>
  submittedBy: string | undefined | null = null
  sessionTypes = ["Admission Rapport building counselling", "Regular Counselling", "Discharge Counselling", "Follow-up Counselling"]
  isLoading = false;  // New loading flag
  private subs = new SubSink();
  private dataSub?: Subscription;

  constructor(private readonly matDialog: MatDialog,
    private datePipe: DatePipe,
    private centreService: CentreService,
    private readonly counselingService: CounselingService,
    private readonly mEmployeeService: EmployeeService,
    private readonly mLogService: LogService) {
    this._centres$ = this.centreService.getAllCentresOptions().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    )
    this.counsellors$ = this.mEmployeeService.getCounsellers()

  }

  clearAll() {
    this.start = undefined;
    this.end = undefined;
    this.selectedCentre = this.all;
    this.centreControl.reset();
    this.submittedBy = null; // Reset counsellor filter

    this.dataSource.data = [];
    this.sessionType = null;
    this.submittedBy = null;

    this.search(); // Optionally trigger search after clearing filters
  }


  ngOnInit(): void {

    this.subs.sink = this.counselingService.fetchGroupSessions().pipe(
      map(sessions => sessions.map(session => ({
        ...session,
        childrenNames: session.children.map((child: any) => child.childName?.join(''))
      })))
    )
      .subscribe(tables => {
        console.log(tables)
        tables.forEach((it: any) => {
          // it.childrenNames = this.getchildNames(it.children)
          it.showEdit = this.editAccess(it)
        })
        this.data = tables
        this.data.reverse()
        this.dataSource = new MatTableDataSource(tables);
        this.dataSource = new MatTableDataSource(this.data);

        //   CUSTOM FILTER LOGIC (SAFE)
        this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
          const search = filter.trim().toLowerCase();

          return (
            data.childrenNames?.toLowerCase().includes(search) ||
            this.getCenterNames(data.centres)?.toLowerCase().includes(search) ||
            this.getTopicsCovered(data.topicsCovered)?.toLowerCase().includes(search) ||
            data.submittedBy?.toLowerCase().includes(search) ||
            this.getDate(data.date)?.toLowerCase().includes(search)
          );
        };

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort
        this.isLoading = false
      })
  }

  openGroupSessionDialog() {
    this.matDialog.open(AddGroupSessionComponent, {
      disableClose: true,
    })

  }

  search() {
    // Fetch sessions based on selected centre
    this.isLoading = true;  // Start loading
    this.dataSub?.unsubscribe();
    this.dataSub = this.counselingService.fetchGroupSessionsSorted(this.selectedCentre)
      .pipe(
        map(tables => tables.map((session: any) => ({
          ...session,
          childrenNames: session.children.map((child: { childName: any; }) => child.childName).join(','),
        })))
      )
      .subscribe(tables => {
        console.log(tables);
        this.data = tables;
        this.mAllData = tables;
        this.data.forEach((it: any) => {
          it.showEdit = this.editAccess(it);
        });

        // Apply counsellor filter
        if (this.submittedBy !== null && this.submittedBy !== 'All Counsellors') {
          this.data = this.data.filter((x: any) => x.submittedBy === this.submittedBy);
          this.isLoading = false;  // Stop loading
        }

        // Apply date range or other filters as needed
        if (this.start && this.end) {
          this.sortSessionByDate();
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;  // Stop loading

      });
    //this.isLoading = false;  // Stop loading
  }


  search4() {
    this.dataSub?.unsubscribe();
    this.dataSub = this.counselingService.fetchGroupSessionsSorted(this.selectedCentre)
      .pipe(
        map(tables => tables.map((session: any) => ({
          ...session,
          childrenNames: session.children.map((child: { childName: any; }) => child.childName).join(','),
        })))
      )
      .subscribe(tables => {
        console.log(tables);
        this.data = tables;
        this.mAllData = tables;
        this.data.forEach((it: any) => {
          it.showEdit = this.editAccess(it);
        });

        // Apply counsellor filter
        if (this.submittedBy !== null) {
          if (this.submittedBy !== 'All Counsellors') {
            this.data = this.data.filter((x: any) => x.submittedBy === this.submittedBy);
          }
        }

        // Apply date range or other filters as needed
        if (this.start && this.end) {
          this.sortSessionByDate();
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }
  // Ensure 'All Counsellors' option is correctly handled
  onCounsellorSelectOld($event: MatSelectChange) {
    if ($event.value === null) {
      this.submittedBy = null; // Handle null value appropriately if needed
    } else {
      this.submittedBy = $event.value; // Set submittedBy to selected counsellor
    }

    if (this.submittedBy === null) {
      this.submittedBy = 'All Counsellors'; // Set submittedBy to 'All Counsellors' if null
    }

    // Call your filter method or search here
    this.search();
  }
  onCounsellorSelect($event: MatSelectChange) {
    if ($event.value === null) {
      this.submittedBy = 'All Counsellors'; // Ensure All Counsellors is shown
    } else {
      this.submittedBy = $event.value;
    }
    this.search(); // Apply the search/filter method
  }
  search3() {
    this.dataSub?.unsubscribe();
    this.dataSub = this.counselingService.fetchGroupSessionsSorted(this.selectedCentre)
      .pipe(
        map(tables => tables.map((session: any) => ({
          ...session,
          childrenNames: session.children.map((child: { childName: any; }) => child.childName).join(','),
        })))
      )
      .subscribe(tables => {
        console.log(tables);
        this.data = tables;
        this.mAllData = tables;
        this.data.forEach((it: any) => {
          it.showEdit = this.editAccess(it);
        });

        // Apply counsellor filter
        if (this.submittedBy) {
          this.data = this.data.filter((x: any) => x.submittedBy === this.submittedBy);
        }

        // Apply date range or other filters as needed
        if (this.start && this.end) {
          this.sortSessionByDate();
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  search2() {
    // alert(this.start )
    this.dataSub?.unsubscribe();
    this.dataSub = this.counselingService.fetchGroupSessionsSorted(this.selectedCentre)
      .pipe(
        map(tables => tables.map((session: any) => ({
          ...session,
          childrenNames: session.children.map((child: { childName: any; }) => child.childName).join(','),
        })))
      )

      .subscribe(tables => {
        console.log(tables)
        this.data = tables
        this.mAllData = tables
        this.data.forEach((it: any) => {
          // it.children = this.getchildNames(it.children)
          it.showEdit = this.editAccess(it)
        })
        // this.data.reverse()
        if (this.start != null && this.end != null) {
          this.sortSessionByDate()
        }
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;

        this.dataSource.paginator = this.paginator;


      })
  }

  // getChildrenList() {
  //   this.dataSource.
  // }
  getchildNames(children: any[]): string {
    let str = ''
    children.forEach((it, index) => {
      if (children.length - 1 == index) str += it.childName + ' '
      else str += it.childName + ', '
    })
    return str
  }

  getCenterNames(centres: any): string {
    let str = ''
    centres.forEach((it: { centreName: string; }, index: number) => {
      if (centres.length - 1 == index) str += it.centreName + ' '
      else str += it.centreName + ', '
    })
    return str
  }

  getTopicsCovered(centres: any[]): string {
    let str = ''
    centres.forEach(it => {
      str += it + ' '
    })
    return str
  }

  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    return this.datePipe.transform(d, 'dd-MMM-yyyy')
  }

  viewDialog(element: any) {
    this.matDialog.open(ViewGroupSessionComponent, {
      data: element,
      width: '800%',
      height: '90%'
    })
    let activity = {
      date: new Date().getTime(),
      section: 'Group Counseling',
      action: 'View',

      description: `Session Viewed in Counseling by`,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  viewEdit(element: any) {
    this.matDialog.open(EditGroupCounselingComponent, {
      data: element,
      width: '800%',
      disableClose: true,
      height: '90%'
    })
  }

  @needConfirmation()
  delete(element: any) {
    this.counselingService.deleteGroupAssessment(element)
    let activity = {
      date: new Date().getTime(),
      section: 'Group Counseling',
      action: 'Delete',

      description: `Session Deleted in Counseling by`,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }

  onCentreSelect($event: MatSelectChange) {
    let c = $event.value
    this.selectedCentre = c as CentreOption

  }

  ngAfterViewInit(): void {
    // this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.dataSub?.unsubscribe();
  }

  // editAccess(element: any): boolean {
  //   console.log('into editAccess')
  //   // const currentTimestamp = firebase.firestore.Timestamp.fromDate(this.currentDate);
  //   const userData = JSON.parse(localStorage.getItem('userData')!)
  //   const username = userData?.userName
  //   // alert(currentDate.getTime() - element.createdAt)
  //
  //   // console.log(element.createdAt,this.currentDate )
  //   // console.log(this.currentDate - element.createdAt ,this.currentDate - element.createdAt <= 86400000)
  //   // console.log('CreatedAt',)
  //   return (username == element.submittedBy && ((this.currentDate - element.createdAt) <= 86400000*2))
  // }
  // editAccess(element: any): boolean {
  //   const ONE_DAY_IN_MILLISECONDS = 86400000;
  //   const TWO_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 2;
  //   const THREE_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 3;
  //   const FOUR_DAYS_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 4;
  //   // console.log('into editAccess')
  //   // const currentTimestamp = firebase.firestore.Timestamp.fromDate(this.currentDate);
  //   const userData = JSON.parse(localStorage.getItem('userData')!)
  //   const username = userData?.userName
  //   // alert(currentDate.getTime() - element.createdAt)
  //   const currentTimestamp = Timestamp.now();
  //   const sessionTimestamp = element.createdAt
  //   // console.log('element.createdAt',element.createdAt)
  //   // const sessionTimestamp = firebase.firestore.Timestamp.fromDate((element.createdAt  as Timestamp).toDate()).toMillis()
  //   const timeDifference = currentTimestamp.toMillis() - sessionTimestamp;
  //
  //   return (username === element.submittedBy && timeDifference <= FOUR_DAYS_IN_MILLISECONDS) ||username=='Krisha Shah'
  //   // console.log(element.createdAt,this.currentDate )
  //   // console.log(this.currentDate - element.createdAt ,this.currentDate - element.createdAt <= 86400000)
  //   // console.log('CreatedAt',)
  //   // return (username == element.personConductingTest && ((this.currentDate - element.createdAt) <= TWO_DAYS_IN_MILLISECONDS))
  // }
  editAccess(element: any): boolean {

    const FOUR_DAYS = 4 * 24 * 60 * 60 * 1000;
    const TWO_DAYS = 4 * 24 * 60 * 60 * 1000;

    const userData = JSON.parse(localStorage.getItem('userData')!);
    const username = userData?.userName;

    const sessionTime =
      element.date?.seconds ? element.date.seconds * 1000 : element.createdAt;

    const timeDifference = Date.now() - sessionTime;

    return (
      (username === element.submittedBy && timeDifference <= TWO_DAYS) ||
      username === 'Krisha Shah'
    );
  }


  private sortSessionByDate() {
    this.data = this.data.filter((x: any) => x.date.toDate() >= this.start!! && x.date.toDate() <= this.end!!)
    this.data.forEach((it: any) => {
      // it.children = this.getchildNames(it.children)
      it.showEdit = this.editAccess(it)
    })
    this.dataSource = new MatTableDataSource(this.data)
    console.log(this.data)
  }

  // applyfilters() {
  //   const searchValue = this.input.nativeElement.value.trim().toLowerCase();
  //   this.dataSource.filter = searchValue;
  // }

  applyfilters() {
    const searchValue = this.input.nativeElement.value.trim().toLowerCase();
    this.dataSource.filter = searchValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadExcel() {
    const tableData = this.dataSource?.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource?.data;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Date</th>
        <th>Children Names</th>
        <th>Centres</th>
        <th>Topics Covered</th>
         <th>Submitted By</th>
         <th>Created At</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
     <tr>
        <td>${index + 1}</td>
        <td>${x.date && x.date.toDate
          ? new Date(x.date.toDate()).toLocaleDateString('en-GB')
          : '-'
        }</td>
        <td>${x.childrenNames ?? '-'}</td>
        <td>${this.getCenterNames(x.centres) ?? '-'}</td>
        <td>${this.getTopicsCovered(x.topicsCovered) ?? '-'}</td>
        <td>${x.submittedBy ?? '-'}</td>
        <td>${x.createdAt
          ? new Date(x.createdAt).toLocaleDateString('en-GB')
          : '-'
        }</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Education_Follow_Up_Assessment_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }



  protected readonly PermissionType = PermissionType;
}
